import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./component/font-awesome-4.7.0/css/font-awesome.css"
import "./component/font-awesome-4.7.0/css/font-awesome.min.css"
import { useEffect } from "react";
import Home from "./component/section/home/home";
import Header from "./component/section/header/header";
import Footer from "./component/section/footer/footer"
import TourDetails from "./component/section/pages/tourDetails/tourDetails";
import Request from "./component/section/pages/request/request";
import ToursList from "./component/section/pages/toursList/toursList";
import About from "./component/section/pages/about/about";
import Gallery from "./component/section/pages/gallery/gallery";
import Contact from "./component/section/pages/contact/contact";
import Question from "./component/section/pages/question/question";
import Feedback from "./component/section/pages/feedback/feedback";
import Souvenirs from "./component/section/souvenirs/souvenirs";
import "./app.css"
import "./media/media1199.css"
import "./media/media1023.css"
import "./media/media767.css"
import "./media/media581.css"
import "./media/media481.css"
import "./media/media420.css"
import { useTranslation } from "react-i18next";
import useLocalStorage from "./hooks/use-localstorage";
import i18n from './i18n';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
const App = () => {

    const { t } = useTranslation();
    const [language, setLanguage] = useLocalStorage('language', 'rus');
    const [langcat, setlangcat] = useState(language);
    const changeLang = (e) => {
        if (e === 'eng') {
            i18n.changeLanguage(e);
            setLanguage(e);
            setlangcat(e);
            changeLangMenu();
        }
        else if (e === 'rus') {
            i18n.changeLanguage(e);
            setlangcat(e);
            setLanguage(e);
            changeLangMenu();
        }
        else if (e === 'itl') {
            i18n.changeLanguage(e);
            setlangcat(e);
            setLanguage(e);
            changeLangMenu();
        }
    };
    const changeLangMenu = () => {
        const changeLangBtn = document.querySelector(".head-3-btn-menu");
        if (changeLangBtn.classList.contains("active") == true) {
            changeLangBtn.classList.remove("active")
        }
        else {
            changeLangBtn.classList.add("active")

        }
    }
    const [scoreTours, setScoreTours] = useState(0);
    const [themeLogo, setThemeLogo] = useState();
    const location = useLocation();
    const isHome = location.pathname === "/";


    useEffect(() => {
        const head1 = document.querySelector(".head-1");
        const head2 = document.querySelector(".head-2");
        const head3 = document.querySelector(".head-3");

        if (isHome == true) {
            const homeflextexts = document.querySelector(".home-flex-texts");
            if (themeLogo == true) {
                head1.classList.add("white");
                head2.classList.add("white");
                head3.classList.add("white");
                homeflextexts.classList.add("white");
            } else {
                head1.classList.remove("white");
                head2.classList.remove("white");
                head3.classList.remove("white");
                homeflextexts.classList.remove("white");
            }
        }
        if (isHome == false) {
            if (themeLogo == true) {
                head1.classList.add("white");
                head2.classList.add("white");
                head3.classList.add("white");
            } else {
                head1.classList.remove("white");
                head2.classList.remove("white");
                head3.classList.remove("white");
            }
        }
    }, [themeLogo]);
    useEffect(() => {
        setThemeLogo(isHome);
    }, [isHome]);
    return (
        <>
            <ScrollToTop />
            <Header
                t={t}
                changeLang={changeLang}
                language={language}
                changeLangMenu={changeLangMenu}
            />
            <Routes>
                <Route path="*"
                    element={
                        <Home
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                        />
                    }
                />
                <Route path="/"
                    element={
                        <Home
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            setThemeLogo={setThemeLogo}
                        />
                    }
                />
                <Route exact path="/tours/:id"
                    element={
                        <TourDetails
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/tours"
                    element={
                        <ToursList
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/tours/:id/request"
                    element={
                        <Request
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/about"
                    element={
                        <About
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/gallery"
                    element={
                        <Gallery
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/support"
                    element={
                        <Question
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/contact"
                    element={
                        <Contact
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route exact path="/Souvenirs"
                    element={
                        <Souvenirs
                            t={t}
                            langcat={langcat}
                            Swiper={Swiper}
                            SwiperSlide={SwiperSlide}
                            Navigation={Navigation}
                            Pagination={Pagination}
                            Mousewheel={Mousewheel}
                            Autoplay={Autoplay}
                            scoreTours={scoreTours}
                            setScoreTours={setScoreTours}
                        />
                    }
                />
                <Route path="/feedback/:id"
                    element={
                        <Feedback
                            t={t}
                        />
                    }
                />
            </Routes>

            <Footer
                t={t}
                changeLang={changeLang}
                language={language}
                changeLangMenu={changeLangMenu}
            />
        </>
    )
}
export default App;